module.exports = __webpack_public_path__ + "icons_02.d3a923ef.svg";